<template>
  <v-container class="no-margins">
    <v-expand-transition v-if="searchedexemptions && searchedexemptions.length > 0">
      <v-expansion-panels class="mt-0">
        <v-expansion-panel
          v-for="(exemption, index) in searchedexemptions"
          :key="exemption.id"
          :aria-label="$t('labels.existing-applications')"
        >
          <v-expansion-panel-header expand-icon="$sl-arrow-down" two-line>
            <div>
              <div
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyEmployee',
                      params: {
                        id: $route.params.id,
                        employee_id: exemption.person.employments.find(
                          (x) => x.companyId == $route.params.id
                        ).id,
                      },
                    });
                  })
                "
                class="header-title text-capitalize"
                v-if="exemption && exemption.person"
              >
                {{ exemption.person | fullName }}
              </div>
              <div class="ellipsis">
                <div class="caption gray">
                  {{ $t("company.exemption-type") }} ({{
                    getProfessionString(exemption.professions)
                  }})
                </div>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-for="(p, index) in exemption.professions" :key="'key_' + index">
              <h6 class="subtitle-2">{{ $t("company.exemption-type") }}: {{ p.name }}</h6>
              <p class="caption">
                {{ $t("company.exemption-issued-by") }} {{ p.approvedOn | date }}
              </p>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-expand-transition>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import find from "lodash/find";

import { CompanyRoles } from "@/components/mixins";

// @group Company
// CompanyEmployeeList component
export default {
  name: "CompanyExemptionsItems",

  mixins: [CompanyRoles],

  props: {
    searchedexemptions: Array,
  },

  watch: {},
  data() {
    return {};
  },

  components: {},

  created() {},

  methods: {
    /**
     * @vuese
     * Used to transform profession to string devided by a comma
     * @arg The argument is an array representing professions
     */
    getProfessionString(p) {
      let ret = "";
      p.forEach((element, index) => {
        if (ret != "") ret += ", ";
        ret += element.name;
      });
      return ret.replace(/\s*,\s*/g, ", ");
    },
  },
};
</script>
